import React from 'react';
import { LuTriangleAlert } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';

import { AgentRoleWarning } from '../../shared/utils/agent-role';
import { Modal } from '../ui/Modal';

interface AgentRoleWarningModalProps {
  projectId: string;
  warning: AgentRoleWarning;
  onContinue: () => void;
  onCancel: () => void;
}

// MF-39 — shown right before starting/assigning a coding task on a project with no "working"
// and/or "review" status configured. Advisory only: the agent still runs, it just won't move the
// task on the board the way the user might expect.
export const AgentRoleWarningModal: React.FC<AgentRoleWarningModalProps> = ({
  projectId,
  warning,
  onContinue,
  onCancel,
}) => {
  const navigate = useNavigate();

  return (
    // This is often opened from inside TaskModal, so render above the default Modal layer (100).
    <Modal onClose={onCancel} className="max-w-sm" labelledBy="agent-role-warning-title" zIndex={110}>
      <div className="card-body p-5 gap-3">
        <div className="flex items-center gap-2">
          <LuTriangleAlert size={18} className="text-warning shrink-0" />
          <div id="agent-role-warning-title" className="text-base font-semibold">
            Board won&apos;t update automatically
          </div>
        </div>
        <div className="text-sm opacity-70 space-y-1.5">
          {warning.missingWorking && (
            <p>
              The coding agent won&apos;t move this task on the board because no &quot;working&quot; status is set for
              this project.
            </p>
          )}
          {warning.missingReview && (
            <p>
              No &quot;review&quot; status is set either — the task will stay in the working column (or wherever it is
              now) once the agent finishes.
            </p>
          )}
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <button className="btn btn-ghost btn-sm" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-outline btn-sm" onClick={() => navigate(`/standalone/${projectId}?settings=1`)}>
            Fix in settings
          </button>
          <button className="btn btn-primary btn-sm" onClick={onContinue}>
            Continue anyway
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AgentRoleWarningModal;
